export enum SelectArticlePropertyType {
  Url = "url",
  ExternalInjections = "externalInjections",
}
